module.exports = __webpack_public_path__ + "static/media/996765.883c4aa0.png";